var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnlockVector5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 11,
    viewBox: "0 0 8 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 0C5.11103 0 5.8449 0.509162 6.28125 1.1582C6.69956 1.78069 6.83301 2.50997 6.83301 3V5H7.15039C7.65157 5.00022 8 5.4249 8 5.875V10.125C8 10.5751 7.65157 10.9998 7.15039 11H0.849609C0.348462 10.9998 0 10.5751 0 10.125V5.875C0 5.42488 0.348462 5.00022 0.849609 5L0.924805 5.00684C0.949388 5.00312 0.974379 5 1 5H3.5C3.77614 5 4 5.22386 4 5.5C4 5.77614 3.77614 6 3.5 6H1V10H7V6H6.33301C6.05701 5.99982 5.83301 5.77603 5.83301 5.5V3C5.83301 2.65684 5.73357 2.13589 5.45215 1.7168C5.18846 1.3244 4.75536 1 4 1C3.24464 1 2.81154 1.3244 2.54785 1.7168C2.26643 2.13589 2.16699 2.65684 2.16699 3C2.16699 3.27603 1.94298 3.49982 1.66699 3.5C1.39085 3.5 1.16699 3.27614 1.16699 3C1.16699 2.50997 1.30044 1.78069 1.71875 1.1582C2.1551 0.509162 2.88897 0 4 0Z",
    fill: "#A6A6A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlockVector5);
export default __webpack_public_path__ + "static/media/UnlockVector5.5d45aec69134bcbbadf72d756d9b8287.svg";
export { ForwardRef as ReactComponent };